<template>
    <div class="analysisTable">
        <div class="analysisTable__header">
            <div class="analysisTable__header--icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="25" height="23" viewBox="0 0 25 23" fill="none">
                    <path
                        d="M4.38821 16.1254L2 21.6979H22.6979L20.3096 16.1254M4.38821 16.1254H20.3096M4.38821 16.1254H5.85728M20.3096 16.1254H18.8406M19.5136 8.16464C19.5136 12.9411 12.3489 18.5136 12.3489 18.5136C12.3489 18.5136 5.18429 12.9411 5.18429 8.16464C5.18429 4.2623 8.44659 1 12.3489 1C16.2513 1 19.5136 4.2623 19.5136 8.16464ZM12.3489 10.5529C13.6679 10.5529 14.7371 9.48362 14.7371 8.16464C14.7371 6.84566 13.6679 5.77643 12.3489 5.77643C11.0299 5.77643 9.96071 6.84566 9.96071 8.16464C9.96071 9.48362 11.0299 10.5529 12.3489 10.5529Z"
                        stroke="#3682F3" stroke-width="2" stroke-linecap="round" />
                </svg>
            </div>
            <div class="analysisTable__header--title">Endereço</div>
        </div>
        <div class="analysisTable__content" v-if="!isLoading">
            <div class="analysisTable__content--list">
                <div class="analysisTable__content--list-item">
                    <div class="item">
                        <div class="item__container">
                            <div class="item__container--title">Cidade</div>
                            <div class="item__container--value">{{ city }}</div>
                            <div class="item__container--pill blue" @click="goToMaps()">Ver no maps
                            </div>
                        </div>
                    </div>
                </div>
                <div class="analysisTable__content--list-item">
                    <div class="item">
                        <div class="item__container">
                            <div class="item__container--title">País</div>
                            <div class="item__container--value">{{ country }}</div>
                        </div>
                    </div>
                </div>
                <div class="analysisTable__content--list-item">
                    <div class="item">
                        <div class="item__container">
                            <div class="item__container--title">Local</div>
                            <div class="item__container--value">{{ continent }}</div>

                        </div>
                    </div>
                </div>
                <div class="analysisTable__content--list-item no-border">
                    <div class="item">
                        <div class="item__container">
                            <div class="item__container--title">Cep</div>
                            <div class="item__container--value">{{ zip_code }}</div>
                            <!-- <div class="item__container--pill" v-if="countCpf && countCpf > 0"
                                :class="countCpf > 5 ? 'red' : 'blue'">{{ zip_code }}</div> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-else class="row justify-content-center p-5">
            <div class="spinner-border" role="status">
                <span class="sr-only">Loading...</span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'AnalysisTableAddress',
    props: {
        data: {
            type: Object,
            required: true
        },
        totalizer: {
            type: Object,
            required: false
        },
    },
    computed: {
        isLoading() {
            return this.$store.getters["getLoadingAnalysisSelldata"]
        },
        city() {
            return this.data && this.data.risk_body && this.data.risk_body.ip_address && this.data.risk_body.ip_address.city && this.data.risk_body.ip_address.city.names && this.data.risk_body.ip_address.city.names['pt-BR'] ? this.data.risk_body.ip_address.city.names['pt-BR'] : '---';
        },
        continent() {
            return this.data && this.data.risk_body && this.data.risk_body.ip_address && this.data.risk_body.ip_address.continent && this.data.risk_body.ip_address.continent.names && this.data.risk_body.ip_address.continent.names['pt-BR'] ? this.data.risk_body.ip_address.continent.names['pt-BR'] : '---';
        },
        country() {
            return this.data && this.data.risk_body && this.data.risk_body.ip_address && this.data.risk_body.ip_address.country && this.data.risk_body.ip_address.country.names && this.data.risk_body.ip_address.country.names['pt-BR'] ? this.data.risk_body.ip_address.country.names['pt-BR'] : '---';
        },
        zip_code() {
            return this.data && this.data.client && this.data.client.zipcode ? this.data.client.zipcode : '---'
        },
        lat() {
            return this.data && this.data.risk_body && this.data.risk_body.ip_address && this.data.risk_body.ip_address.location && this.data.risk_body.ip_address.location.latitude ? this.data.risk_body.ip_address.location.latitude : '---';
        },
        long() {
            return this.data && this.data.risk_body && this.data.risk_body.ip_address && this.data.risk_body.ip_address.location && this.data.risk_body.ip_address.location.longitude ? this.data.risk_body.ip_address.location.longitude  : '---';
        },
        maps_url() {
            return 'https://www.google.com/maps/search/?api=1&query=' +
                this.lat +
                ',' +
                this.long;
        }
    },
    methods: {
        goToMaps() {
            if (this.maps_url) {
                const url = this.maps_url;
                window.open(url, '_blank');
            }

        }
    }
};
</script>

<style scoped lang="scss">
.analysisTable {
    width: 100%;
    margin: 20px 0px 0px 0px;

    &__header {
        padding: 0px 20px;
        display: flex;
        justify-content: flex-start;
        align-items: center;

        &--icon {
            width: 20.698px;
            height: 20.698px;
            flex-shrink: 0;
        }

        &--title {
            color: #3682F3;
            font-size: 18px;
            font-style: normal;
            font-weight: 700;
            line-height: normal;
            margin-left: 14px;
        }
    }

    &__content {
        height: auto;
        width: 100%;

        hr {
            background: #E5E5E5;
        }

        &--list {
            height: auto;
            width: 100%;
            margin: 20px 0px;

            &-item {
                border-bottom: solid 1px #E5E5E5;

                .item {
                    position: relative;

                    &__container {
                        padding: 20px;

                        &--title {
                            color: #B1B1B1;
                            font-size: 0.8em;
                            font-style: normal;
                            font-weight: 400;
                            line-height: normal;
                        }

                        &--value {
                            color: #141414;
                            font-size: 0.9em;
                            font-style: normal;
                            font-weight: 600;
                            line-height: normal;
                            width: calc(100% - 40px);
                            overflow-x: hidden;
                            white-space: nowrap;
                            text-overflow: ellipsis;
                        }

                        &--pill {
                            position: absolute;
                            right: 20px;
                            top: 30%;
                            width: auto;
                            font-size: 0.7em;
                            padding: 4px 10px;
                            font-size: 12px;
                            font-style: normal;
                            font-weight: 600;
                            line-height: normal;
                            border-radius: 50px;
                            cursor: pointer;

                        }
                    }

                }
                &.no-border {
                    border-bottom: none !important;
                }

            }

        }
    }
}

.blue {
    background: rgba(54, 130, 243, 0.10);
    color: #3682F3;
}

.red {
    background: rgba(255, 95, 95, 0.10);
    color: #FF5F5F;
}
</style>